const SheeruQuickView = {
  
  open: function(handle) {
    const overlay = document.getElementById('SheeruQVOverlay');
    const btn = document.getElementById('SQV_Btn');
    document.body.style.cursor = 'wait';
    btn.innerText = 'Loading...';

    fetch(`/products/${handle}.js`)
      .then(response => response.json())
      .then(product => {
        this.buildModal(product);
        overlay.classList.add('active');
        document.body.style.cursor = 'default';
        document.body.style.overflow = 'hidden'; 
      })
      .catch(e => console.error(e));
  },

  close: function() {
    document.getElementById('SheeruQVOverlay').classList.remove('active');
    document.body.style.overflow = ''; 
  },

  buildModal: function(product) {
    // 1. Basic Info
    document.getElementById('SQV_Title').innerText = product.title;
    document.getElementById('SQV_Price').innerText = this.formatMoney(product.price);
    document.getElementById('SQV_Link').href = product.url;
    
    // Description Strip
    const div = document.createElement("div");
    div.innerHTML = product.description;
    document.getElementById('SQV_Desc').innerText = div.textContent || div.innerText || "";

    // 2. IMAGE GALLERY LOGIC (UPDATED)
    const imageContainer = document.querySelector('.sheeru-qv-image-col');
    imageContainer.innerHTML = ''; // Clear previous images
    
    // Loop through ALL images and add them
    if(product.images.length > 0) {
      product.images.forEach(imgUrl => {
        const img = document.createElement('img');
        img.src = imgUrl; // Using default JS returned URL
        img.className = 'sheeru-qv-img';
        imageContainer.appendChild(img);
      });
    } else {
       imageContainer.innerHTML = '<div style="padding:2rem; color:#999;">No Image</div>';
    }

    // 3. Variants Logic
    const formOptions = document.getElementById('SQV_Options');
    formOptions.innerHTML = '';
    
    const variantInput = document.getElementById('SQV_VariantID');
    const btn = document.getElementById('SQV_Btn');

    const currentVariant = product.variants[0];
    variantInput.value = currentVariant.id;

    if (currentVariant.available) {
      btn.innerText = 'Add to Cart';
      btn.disabled = false;
    } else {
      btn.innerText = 'Sold Out';
      btn.disabled = true;
    }

    if (product.variants.length > 1) {
      product.options.forEach((option, index) => {
        const wrapper = document.createElement('div');
        wrapper.className = 'sheeru-qv-option-row';
        
        const label = document.createElement('label');
        label.className = 'sheeru-qv-label';
        label.innerText = option.name;
        
        const select = document.createElement('select');
        select.className = 'sheeru-qv-select';
        
        option.values.forEach(val => {
          const opt = document.createElement('option');
          opt.value = val;
          opt.innerText = val;
          select.appendChild(opt);
        });

        select.addEventListener('change', () => this.updateVariant(product));
        wrapper.appendChild(label);
        wrapper.appendChild(select);
        formOptions.appendChild(wrapper);
      });
    }
  },

  updateVariant: function(product) {
    const selects = document.querySelectorAll('.sheeru-qv-select');
    const selectedOptions = Array.from(selects).map(s => s.value);
    
    const matchedVariant = product.variants.find(variant => {
      return variant.options.every((opt, index) => opt === selectedOptions[index]);
    });

    const btn = document.getElementById('SQV_Btn');
    const price = document.getElementById('SQV_Price');
    const input = document.getElementById('SQV_VariantID');

    if (matchedVariant) {
      input.value = matchedVariant.id;
      price.innerText = this.formatMoney(matchedVariant.price);
      
      // OPTIONAL: Scroll to matching image if you want logic here
      // But keeping all images visible is better for "Gallery" feel

      if (matchedVariant.available) {
        btn.innerText = 'Add to Cart';
        btn.disabled = false;
      } else {
        btn.innerText = 'Sold Out';
        btn.disabled = true;
      }
    } else {
      btn.innerText = 'Unavailable';
      btn.disabled = true;
    }
  },

  formatMoney: function(cents) {
    return '$' + (cents / 100).toFixed(2);
  }
};

document.getElementById('SQV_Form').addEventListener('submit', function(e) {
  e.preventDefault();
  const btn = document.getElementById('SQV_Btn');
  const originalText = btn.innerText;
  btn.innerText = 'Adding...';

  const formData = new FormData(this);
  
  fetch(window.Shopify.routes.root + 'cart/add.js', { method: 'POST', body: formData })
  .then(r => r.json())
  .then(data => {
    fetch(window.Shopify.routes.root + 'cart.js').then(r=>r.json()).then(c => {
       const bubbles = document.querySelectorAll('.cart-count-bubble span');
       if(bubbles.length > 0) {
         bubbles.forEach(el => el.innerText = c.item_count);
       } else {
         const icon = document.getElementById('cart-icon-bubble');
         if(icon && !icon.querySelector('.cart-count-bubble')) {
            icon.insertAdjacentHTML('beforeend', `<div class="cart-count-bubble"><span aria-hidden="true">${c.item_count}</span></div>`);
         }
       }
       // Update Modal Count
       const modalCount = document.getElementById('ModalCount');
       if(modalCount) modalCount.innerText = c.item_count;
    });
    
    SheeruQuickView.close();
    
    // Open Cart Modal Overlay (If it exists on page)
    const cartModal = document.getElementById('SheeruCartModal');
    if(cartModal) {
        document.getElementById('ModalTitle').innerText = data.product_title;
        document.getElementById('ModalPrice').innerText = '$' + (data.price / 100).toFixed(2);
        document.getElementById('ModalImg').src = data.image;
        document.getElementById('SheeruModalOverlay').classList.add('active');
        cartModal.classList.add('active');
    }

    btn.innerText = originalText;
  })
  .catch(e => { console.error(e); btn.innerText = originalText; });
});

document.getElementById('SheeruQVOverlay').addEventListener('click', function(e) {
  if (e.target === this) SheeruQuickView.close();
});